module.exports = __webpack_public_path__ + "static/img/fund1.f2ba759.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/fundClassify/fund1.png
// module id = bcuS
// module chunks = 0